import React, { useEffect, useState } from 'react';
import { FocusContext } from '../../../contexts/FocusContext';
import { Box, SxStyleProp } from 'rebass';
import { Heading } from '../text';
import { space, forms } from '../../../theme';
import { SpacedFormLayout, SpacedFormLayoutProps } from './SpacedFormLayout';

interface FormSectionProps extends SpacedFormLayoutProps {
  name: string;
  focused?: boolean;
  disabled?: boolean;
}

export const FormSection: React.FC<FormSectionProps> = props => {
  const [isFocused, setFocus] = useState(props.focused || false);
  const focusContextValue = { isFocused, setFocus };

  useEffect(() => {
    setFocus(Boolean(props.focused));
  }, [props]);

  const getSectionStyleObj = () => {
    return props.disabled
      ? forms.section.disabled
      : isFocused
      ? forms.section.focused
      : forms.section;
  };

  const getSectionHeadingStyleObj = (): SxStyleProp => {
    const sectionStyleObj = getSectionStyleObj();
    return sectionStyleObj.heading;
  };

  return (
    <FocusContext.Provider value={focusContextValue}>
      <Box
        as={'fieldset'}
        p={space.two}
        pb={`calc(${space.two} - ${space.half})`}
        sx={getSectionStyleObj}
        {...props}
      >
        <Heading tx={'forms'} level={2} sx={getSectionHeadingStyleObj}>
          {props.name}
        </Heading>
        <SpacedFormLayout fieldSpacing={props.fieldSpacing}>
          {props.children}
        </SpacedFormLayout>
      </Box>
    </FocusContext.Provider>
  );
};
